import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Avatar, TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import MattersDetailsPage from "./MattersDetailsPage";
import MatterForm from "./MatterForm";
import { fetchMatterAllInfo } from "services/mattersService";
import { updateAdditionalClients } from "api";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import { useNavigate } from "react-router";
import MattersCreditsandDefaults from "./MattersCreditsDefaults";
import { DocRegisterListTile } from "components/DocumentRegister/DocRegisterListTile";
import { NotesListTile } from "components/Notes/NotesListTile";
import MattersCompletionPage from "./MatterCompletionPage";
import { RiskAssessment } from "components/RiskAssessments";
import { useAllowedLiscence } from "hooks/useAllowedLiscence";
import UndertakingsList from "components/Undertakings/UndertakingsList";
import { useCompany } from "services/companyService";
import AdditionalClientsTab from "./AdditionalClientsTab";
import PaymentProfileTab from "./PaymentProfileTab";

const BASE_OPTIONS = [
  "Details",
  "Credits & Defaults",
  "Completion",
  "Wills & Deeds",
  "Notes",
  "Risk Assessment",
  "Undertakings",
];

const MatterView = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const { subDataCheck } = useAllowedLiscence();
  const matterDetails = useSelector((state) => state.mattersList);
  const [currentMatterDetails, setcurrentMatterDetails] = useState();
  const [actiVeItem, setActiveItem] = useState(0);
  const { data: company } = useCompany();
  const hasMultipleClientsModule = Boolean(company?.modules?.MultipleClients);
  const hasConsultantsModule = Boolean(company?.modules?.Consultants);
  const options = React.useMemo(() => {
    const inserted = [...BASE_OPTIONS];
    if (hasMultipleClientsModule) {
      const idx = inserted.indexOf("Completion");
      inserted.splice(idx + 1, 0, "Additional Clients");
    }
    if (hasConsultantsModule) inserted.push("Payment Profile");
    return inserted;
  }, [hasMultipleClientsModule, hasConsultantsModule]);
  const leadClient = currentMatterDetails?.client || {};

  const handleSaveAdditionalClients = async (clients) => {
    const matterId = currentMatterDetails?.matterId;
    if (!matterId) return;
    const payload = clients.map((c, idx) => ({
      clientId: c.clientId,
      order: c.order ?? idx,
      active: c.active !== false,
    }));
    await updateAdditionalClients(matterId, payload);
    dispatch(fetchMatterAllInfo(matterId));
  };

  const openCaseFile = () => {
    navigate(`/casefiles/${currentMatterDetails?.matterId}`);
  };

  useEffect(() => {
    if (matterDetails !== null) {
      setcurrentMatterDetails(
        matterDetails?.matterViewDetails[props.reference]?.data
      );
    }
  }, [matterDetails]);

  useEffect(() => {
    if (!showForm && currentMatterDetails?.matterId) {
      dispatch(fetchMatterAllInfo(currentMatterDetails?.matterId));
    }
  }, [showForm]);

  return (
    <div className="pt-3 px-2">
      <div className="row">
        <div className={`styles["view-tittle"] col`}>
          <TabStrip
            onSelect={(e) => setActiveItem(e.selected)}
            keepTabsMounted={true}
            selected={actiVeItem}
            // style={{ marginTop: "10px" }}
            className="pagetab mt-3 px-4 h-100"
            animation={false}
          >
            {options.map((item) => {
              return (
                <TabStripTab
                  title={
                    <PageTabItemTitle
                      index={options.indexOf(item)}
                      title={item}
                      selected={actiVeItem}
                    />
                  }
                  key={item}
                >
                  <div style={{ width: "100%" }}>
                    {item === "Details" && (
                      <MattersDetailsPage reference={props.reference} />
                    )}
                    {item === "Credits & Defaults" && (
                      <MattersCreditsandDefaults reference={props.reference} />
                    )}
                    {item === "Completion" && (
                      <MattersCompletionPage
                        reference={props.reference}
                        onMatterUpdated={props.onMatterUpdated}
                      />
                    )}
                    {item === "Additional Clients" && (
                      <AdditionalClientsTab
                        formType="VIEW"
                        leadClient={{
                          clientId:
                            leadClient.clientId ??
                            currentMatterDetails?.clientId ??
                            null,
                          clientRef: leadClient.clientRef,
                          clientName: leadClient.clientName,
                          email: leadClient.email,
                          phone: leadClient.phoneNo,
                          address: leadClient.address,
                        }}
                        additionalClients={
                          currentMatterDetails?.additionalClients || []
                        }
                        onSave={handleSaveAdditionalClients}
                      />
                    )}
                    {item === "Wills & Deeds" && (
                      <DocRegisterListTile matterId={currentMatterDetails} />
                    )}

                    {item === "Notes" && (
                      <NotesListTile
                        matterId={currentMatterDetails?.matterId}
                      />
                    )}

                    {item === "Risk Assessment" && (
                      <RiskAssessment
                        matterId={currentMatterDetails?.matterId}
                      />
                    )}

                    {item === "Undertakings" && (
                      <UndertakingsList
                        matterId={currentMatterDetails?.matterId}
                        clientId={currentMatterDetails?.clientId}
                        isView={true}
                      />
                    )}

                    {item === "Payment Profile" && (
                      <PaymentProfileTab
                        matterId={currentMatterDetails?.matterId}
                      />
                    )}
                  </div>
                </TabStripTab>
              );
            })}
          </TabStrip>
        </div>
      </div>

      {showForm && (
        <MatterForm
          reference={props.reference}
          isView={true}
          setshowMatterForm={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default MatterView;
